import apiClient from './api';

class AuthService {
  // Login user
  async login(email, password) {
    const response = await apiClient.post('/auth/login', {
      email,
      password
    });
    
    if (response.data.token) {
      localStorage.setItem('authToken', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    
    return response.data;
  }

  // Logout user
  logout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  }

  // Get current user
  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  // Check if user is authenticated
  isAuthenticated() {
    return !!localStorage.getItem('authToken');
  }

  // Get auth token
  getToken() {
    return localStorage.getItem('authToken');
  }

  // Check if token is expired or about to expire (within 1 hour)
  isTokenExpired() {
    const token = this.getToken();
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);
      const expirationTime = payload.exp;
      const oneHourInSeconds = 60 * 60;
      
      // Return true if token expires within the next hour
      return (expirationTime - currentTime) < oneHourInSeconds;
    } catch (error) {
      console.error('Error parsing token:', error);
      return true;
    }
  }

  // Get token expiration time
  getTokenExpiration() {
    const token = this.getToken();
    if (!token) return null;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return new Date(payload.exp * 1000);
    } catch (error) {
      console.error('Error parsing token expiration:', error);
      return null;
    }
  }

  // Refresh token
  async refreshToken() {
    try {
      // Use skipAuthRefresh flag to prevent infinite loop in request interceptor
      const response = await apiClient.post('/auth/refresh', {}, {
        skipAuthRefresh: true
      });

      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }

      return response.data;
    } catch (error) {
      // If refresh fails, logout user
      this.logout();
      throw error;
    }
  }

  // Get user profile
  async getProfile() {
    const response = await apiClient.get('/auth/profile');
    return response.data;
  }
}

export default new AuthService(); 